import React, { FC } from "react";
import { Select } from "antd";
import "../../App.css";
import { AllMonths } from "./helper";

interface Props {
  selectedMonth: number;
  setSelectedMonth: (e: number) => void;
}

const MonthDropdown: FC<Props> = ({ selectedMonth, setSelectedMonth }) => (
  <div style={{ marginBottom: '16px' }}>
    <label style={{ marginRight: '12px', fontWeight: 600, fontSize: '15px', color: '#374151' }}>
      Month:
    </label>
    <Select
      value={selectedMonth}
      onChange={(value) => setSelectedMonth(value)}
      style={{ width: 160, height: 40 }}
      size="large"
    >
      {AllMonths.map((month, index) => (
        <Select.Option key={index} value={index}>
          <span style={{ fontSize: '15px' }}>{month}</span>
        </Select.Option>
      ))}
    </Select>
  </div>
);

export default MonthDropdown;
